import { aTypeCreateUpdateTimeoff } from 'actions/shared.types';
import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import fromActionTypeToArray from 'utils/converters/mw/fromActionTypeToArray.util';

// TODO: convert to the newest form using actionEndpointBe
const createUpdateTimeoff = (data, method, oldData) => {
  const bookingId = data.id;
  const salonId = data.salon_id;

  const d = { ...data };
  if (!d.client_id) delete d.client_id;

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: bookingId ? `salon/${salonId}/booking/${bookingId}/` : `salon/${salonId}/booking/`,
      authenticated: true,
      types: fromActionTypeToArray(aTypeCreateUpdateTimeoff),
      params: { data: d, method, oldData },
      config: { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(d) },
    },
  };
};

export default createUpdateTimeoff;
